import MuiToggleButtonGroup, {
  ToggleButtonGroupProps as MuiToggleButtonGroupProps
} from '@mui/material/ToggleButtonGroup';
import React from 'react';

export type ToggleButtonGroupProps = MuiToggleButtonGroupProps;

export const ToggleButtonGroup = (props: ToggleButtonGroupProps) => {
  return <MuiToggleButtonGroup {...props} />;
};
